import React, { useCallback, useEffect, useState } from 'react';
import { CrossCircle } from 'sushiweb/Icons';
import black from 'sushiweb/tokens/color/black';
import { CreateNodeForm } from './HelpSectionForms/CreatNodeForm';
import { Loader } from '../../../../UiKit';
import { EditNodeForm } from './HelpSectionForms/EditNodeForm';

const FormTypes = {
  1: CreateNodeForm,
  2: EditNodeForm,
};

const NodePathComp = ({
  pathString,
  showCompletePath,
  handlePathVisibilty,
}) => {
  return (
    <>
      {pathString && (
        <span className='tw-px-8 tw-flex tw-w-full tw-items-center tw-justify-start tw-mb-8  tw-text-green-700 tw-text-400 tw-font-medium'>
          <span>
            {showCompletePath ? pathString : pathString.substring(0, 50)}
            {pathString?.length > 50 && (
              <span
                className='tw-text-300 tw-ml-4 tw-cursor-pointer tw-font-medium'
                onClick={handlePathVisibilty}
              >
                ...view {showCompletePath ? 'less' : 'more'}
              </span>
            )}
          </span>
        </span>
      )}
    </>
  );
};

const FormComponent = (props) => {
  const Form = FormTypes[props.formType];
  return <Form {...props} />;
};
export const HelpDeskForm = ({
  closeForm,
  formFields = [],
  ruleList = [],
  rootId = null,
  isFormLoading = false,
  refetchRootNodes = () => {},
  nodeType = null,
  parentId = null,
  nodeId = null,
  handleMenuActionPopUp,
  nodeTypes = {},
  setRefetchParentEnable = () => {},
  path = [],
  formType = null,
  nodeNature = null,
}) => {
  const [pathString, setPathString] = useState(null);
  const [showCompletePath, setShowCompletePath] = useState(true);

  useEffect(() => {
    let pathKeys = [];
    const pathObj = {};
    let pathText = '';

    //To get array of nodeIds and pathObj which is a key in the array of objects i.e path
    path.forEach((node) => {
      pathKeys.push(...Object.keys(node));
      const key = pathKeys[pathKeys.length - 1];
      const value = node[key];
      pathObj[key] = value;
    });

    //To ensure correctness of path as nodeid of parent will be less than that of child
    pathKeys.sort();

    //forming path string to render
    pathKeys.forEach((key) => {
      pathText = pathText + pathObj[key] + ` -> `;
    });

    setPathString(pathText);
    if (pathText?.length > 50) setShowCompletePath(false);
  }, [path]);

  const handlePathVisibilty = useCallback(() => {
    setShowCompletePath((prevstate) => !prevstate);
  }, [showCompletePath]);

  return (
    <div className='tw-w-2/5 tw-flex-col tw-bg-base-white tw-fixed tw-right-0 tw-top-0 tw-h-full tw-z-10 tw-pt-8 '>
      <div
        className={`tw-w-full tw-flex tw-items-start tw-justify-between  tw-px-8 ${
          pathString ? 'tw-mb-2' : 'tw-mb-8'
        }`}
      >
        <span className='tw-text-800 tw-font-extrabold'>
          {formType === 1 ? 'Add' : 'Edit'}{' '}
          {nodeType === nodeTypes?.root
            ? 'Root Node'
            : nodeType === nodeTypes?.guideline && formType === 2
            ? 'Guideline Node'
            : 'Child Node'}
        </span>
        <CrossCircle
          size={30}
          color={black}
          className='tw-cursor-pointer'
          onClick={closeForm}
        />
      </div>
      <NodePathComp
        pathString={pathString}
        showCompletePath={showCompletePath}
        handlePathVisibilty={handlePathVisibilty}
      />
      <div className='tw-w-full tw-flex-col tw-overflow-y-auto  tw-relative tw-h-full'>
        {isFormLoading && (
          <div
            className={`tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full `}
          >
            <Loader />
          </div>
        )}
        {formFields?.length && formType && !isFormLoading ? (
          <FormComponent
            formType={formType}
            nodeNature={nodeNature}
            formFields={formFields}
            ruleList={ruleList}
            rootId={rootId}
            refetchRootNodes={refetchRootNodes}
            closeForm={closeForm}
            parentId={parentId}
            nodeId={nodeId}
            handleMenuActionPopUp={handleMenuActionPopUp}
            nodeType={nodeType}
            setRefetchParentEnable={setRefetchParentEnable}
          />
        ) : null}
      </div>
    </div>
  );
};
